import { type FC, type MouseEventHandler } from 'react';

import styled, { css } from '@mint-lib/styled';

import { Box, IconButton, Tooltip, type IconButtonProps } from '@myn/mui';

type Props = {
  title: string;
  disableHoverListener?: boolean;
  arrow?: boolean;
  icon: IconButtonProps['icon'];
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  testId?: string;
  scale: number;
};

const ActionItem: FC<Props> = ({
  title,
  disableHoverListener = false,
  arrow = true,
  testId,
  icon,
  disabled,
  onClick,
  scale,
}) => {
  return (
    <Tooltip
      title={title}
      placement="top"
      disableHoverListener={disableHoverListener}
      arrow={arrow}
    >
      <Box>
        <StyledIconButton
          variant="icon"
          color="primary"
          size="medium"
          data-testid={testId}
          icon={icon}
          disabled={disabled}
          onClick={onClick}
          $scale={scale}
        />
      </Box>
    </Tooltip>
  );
};

export default ActionItem;

const StyledIconButton = styled(IconButton)<{ $scale: number }>`
  ${({ $scale }) => css`
    width: ${32 * $scale}px;
    height: ${32 * $scale}px;
    padding: ${8 * $scale}px;
    & > svg {
      width: ${16 * $scale}px;
      height: ${16 * $scale}px;
    }
  `}
`;
